import { Navigate } from 'react-router-dom';
import { getModuleEntryBySlug } from '@/config/moduleEntries';
import { MODULE_HUB_PATH } from '@/constants/authRoutes';
import { RegisterWizard } from '@/pages/auth/RegisterWizard';

interface ModuleRegisterPageProps {
  slug: string;
}

export function ModuleRegisterPage({ slug }: ModuleRegisterPageProps) {
  const moduleEntry = getModuleEntryBySlug(slug);

  if (!moduleEntry) {
    return <Navigate to={MODULE_HUB_PATH} replace />;
  }

  return <RegisterWizard moduleEntry={moduleEntry} />;
}
